module.exports = __webpack_public_path__ + "static/media/ex-hybrid-img1.572818f0.svg";